import React, { useContext } from "react";
import "./Settings.scss";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router";
import { updateUser } from "../../store/actions/user";
import Form from "../../components/uiComponents/Form";
import { fields } from "../../utils/data";
import Button from "../../components/uiComponents/Button";
import { ModalContext } from "../../components/ModalContext";
import DeleteProfModal from "../../components/modals/DeleteProfModal";
import ResponseModal from "../../components/modals/ResponseModal";

const Settings = () => {
  const { t } = useTranslation();

  const { handleModal } = useContext(ModalContext);
  const dispatch = useDispatch();
  const {
    info: { picture, name, email, phone, company, role },
  } = useSelector((state) => state.user);
  const { goBack } = useHistory();

  const handleDelete = () => {
    handleModal(<DeleteProfModal />);
  };
  const handleSubmit = (values) => {
    dispatch(updateUser(values)).then(() => {
      handleModal(
        <ResponseModal text={t('your_information_changed')} positive={true} />
      );
    });
  };

  return (
    <div className="settings">
      <div className="settings-container">
        <h2
          onClick={() => {
            goBack();
          }}
        >
          <i className="back-arrow-icon"></i>
          {t('back')}
        </h2>
        <div className="settings-body">
          <h3>{t('personal_information')}</h3>
          <div className="user-icon">
            <div className="user-icon_img">
              <img src={picture} alt="" />
            </div>
          </div>
          <Form
            fields={fields}
            initValues={{ picture, name, email, phone, company, role }}
            submitValue={t('save')}
            submitFunc={handleSubmit}
          />
          <div className="delete">
            <h3>{t('delete_profile')}</h3>
            <Button clickFunction={handleDelete}>{t('delete_profile')}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
